const PagePath = {
  HOME_PAGE: "/",
  PRODUCTDETAIL_PAGE: "/product",
  CART_PAGE: "/cart",
  CHECKOUT_PAGE: "/checkout",
  ABOUT_PAGE: "/about",
  CONTACT_PAGE: "/contact",
  RETURN_PAGE: "/return",
  TERMS_PAGE: "/terms",
  CART_PAGE: "/cart",
  SUCCESS_PAGE: "/success",
  SUBSCRIPTION_PAGE: "/subscription",
  PRIVACY_PAGE: "/privacy",
  SHIPPING_PAGE: "/shipping",
  JOIN_PAGE: "/join",
  GUIDE_PAGE: "/guide",
  FAQ_PAGE: "/faq",
  COOKIE_PAGE: "/cookie",
  PRODUCT_PAGE: "/product",
};

export default PagePath;
